import PageSections from './pagesections.js';
import Footer from './footer.js';

const homePage = 'Home Page';

function Home(props) {
    return (
      <div>
        <PageSections capability={homePage} />
      </div>
    )
}

export default Home;